import { useSearchParams } from 'react-router-dom';

export const useIsPrinting = () => {
  const [searchParams] = useSearchParams();
  const isPrinting = searchParams.has('drucken');

  return { isPrinting };
};
